import React from 'react';
import { Star, ShieldCheck, Clock, Truck } from 'lucide-react';
export function ValidatorsBar() {
  return <section className="bg-secondary text-white py-6 border-t border-gray-800" data-id="element-221">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-222">
        <div className="flex flex-col md:flex-row items-center justify-between gap-6 text-center md:text-left" data-id="element-223">
          {/* Rating */}
          <div className="flex flex-col items-center md:items-start" data-id="element-224">
            <div className="flex text-accent-gold mb-1" data-id="element-225">
              {[1, 2, 3, 4, 5].map(star => <Star key={star} className="h-5 w-5 fill-current" data-id="element-226" />)}
              <span className="ml-2 font-bold text-white" data-id="element-227">4.9/5</span>
            </div>
            <p className="text-xs text-gray-400" data-id="element-228">Basado en opiniones reales</p>
          </div>

          {/* Trust Badges */}
          <div className="flex flex-wrap justify-center gap-6 md:gap-8" data-id="element-229">
            <div className="flex items-center gap-2" data-id="element-230">
              <ShieldCheck className="h-5 w-5 text-primary-light" data-id="element-231" />
              <span className="text-sm font-medium" data-id="element-232">Pago seguro</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-233">
              <Truck className="h-5 w-5 text-primary-light" data-id="element-234" />
              <span className="text-sm font-medium" data-id="element-235">Entrega inmediata</span>
            </div>
            <div className="flex items-center gap-2" data-id="element-236">
              <Clock className="h-5 w-5 text-primary-light" data-id="element-237" />
              <span className="text-sm font-medium" data-id="element-238">Garantía 7 días</span>
            </div>
          </div>

          {/* Social Proof Text */}
          <div className="hidden md:block" data-id="element-239">
            <p className="text-sm font-medium text-gray-300" data-id="element-240">
              Más de <span className="text-white font-bold" data-id="element-241">250 lectoras</span>{' '}
              han usado el reset
            </p>
          </div>
        </div>
      </div>
    </section>;
}